import React from "react"
import { useLocation } from "react-router-dom"
import emptyPanel from '../images/emptyPanel.svg'

export function useQuery() {
    return new URLSearchParams(useLocation().search);
} 

export function getFilterList(data, input, key) {
    return data.filter(option => option[key].toUpperCase().includes(input.toUpperCase()))
}

export function NoContent (type="main") {
    return (
        type!=="nowcasting"?<div className='empty-panel'>
            <img src={emptyPanel} alt='empty panel img'/>
            <h3>No Overview for this Panel</h3>
            <p>Start by choosing main financial data with addition<br/>
            of 4 Data sets from the above dropdowns</p>
        </div>:
        <div className='empty-panel'>
            <img src={emptyPanel} alt='empty panel img'/>
            <h3>No Nowcasting for this Panel</h3>
            <p>Start by choosing main financial data with addition<br/>
            of Dataset and predict period from the above dropdowns.</p>
        </div>
    )
}

export function makePairNameValueObject (valueArr, nameArr) {
    return valueArr.map((value, index) => ({value, name: nameArr[index]}))
}

export function formatPrice(n, signDisplay = 'always', locale = 'en-US', currency = 'USD' ) {
    return new Intl.NumberFormat(locale, { style: 'currency', currency ,signDisplay}).format(n || 0)
}

export function formatPercent(n, signDisplay = 'always', locale = 'en-US',) {
    return new Intl.NumberFormat(locale, { style: 'percent', minimumFractionDigits: 2 ,signDisplay}).format(n)
}

export const formatAccountingReport = (n, signDisplay = 'never') => n > 0 ? formatPercent(n, signDisplay) : `(${formatPercent(n, signDisplay)})`

export function formatDecimal(n, signDisplay = 'always', locale = 'en-US') {
    return new Intl.NumberFormat(locale, { style: 'decimal', signDisplay }).format(n)
}

export function formatDefault(n, locale = 'en-US'){
    return new Intl.NumberFormat(locale, { style: 'decimal' }).format(n)
}

export function getArrayOfSpecificKey(arrayOfObj, key = 'datasetValue'){
    return arrayOfObj?.map(obj => obj[key])
}

export function matchColumns(a,b) {
    return a.replace('_',' ').toUpperCase() === b.replace('_',' ').toUpperCase()
}

export const numberFormatter = (type) => {
    switch (type) {
        case 'percent':
            return formatPercent
        case 'price':
        case 'usd':
            return formatPrice
        case 'decimal':
            return formatDecimal
        default:
            return formatDefault
    }
}

export const downloadFile = (file, filename) => {
    const link = document.createElement('a')
    link.href = file
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

export const isFinancial = datasetName => datasetName === 'financial_data'

export const getNowcastingProps = (value, datasetLabels) => datasetLabels.find(({datasetValue, columnValue}) => `${datasetValue}::${columnValue}` === value )

export const arrangeListByIndex = (dataset, listToArrange) => {
    const updatedList = []
    dataset.forEach(data => updatedList.push( listToArrange.find(field => field.datasetValue === `${data.datasetName}: ${data.columnName}`) ))
    return updatedList
}

export const capitalize = string => (string && string[0].toUpperCase() + string.slice(1)) || ""

export const getColumnsOfDatasets = (datasetValue, datasets) => datasets?.find(dataset => dataset.value === datasetValue)?.columns

export const merge = (a, b, i=0) => a.splice(i, 0, ...b) && a

// export const marketCapFormat = (number) => number ? `$${parseFloat(number / 1000000000).toFixed(2)}B` : '-'

export const marketCapFormat = (params) => params?.row?.market_cap ? `${formatPrice(parseFloat(params.row.market_cap / 1000000000), 'auto','en-US',params.row.currency_code)}B` : '-'

export const longNumberFormt = (number) => (
    Intl.NumberFormat('en-US', {
    notation: "compact",
    maximumFractionDigits: 1
    }).format(number)
)

export function generateRGB(opacity) {
    const o = Math.round, r = Math.random, s = 255;
    return 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + opacity || r().toFixed(1) + ')';
}
